import Image from 'next/image'
import type { FC } from 'react'
import styles from './AddressAnimation.module.scss'
import burgerImg from './assets/burger-full-landing.png'

export const AddressAnimation: FC = () => (
  <div className={styles['address-animation']}>
    <video
      autoPlay
      loop
      muted
      playsInline
      aria-hidden="true"
      className={styles['address-animation-video']}
      preload="auto"
    >
      <source src={'/animations/address-container-animation.webm'} type="video/webm" />
      <Image alt="" aria-hidden="true" src={burgerImg}></Image>
    </video>
  </div>
)
